export enum LanguageEnum {
    POLISH= 'POLISH',
    CZECH= 'CZECH',
    ENGLISH= 'ENGLISH',
    GERMAN= 'GERMAN',
    ITALIAN= 'ITALIAN',
    FRENCH= 'FRENCH',
    UKRAINIAN= 'UKRAINIAN',
    SPANISH= 'SPANISH',
    RUSSIAN= 'RUSSIAN',
}
